module.exports = __webpack_public_path__ + "img/sourire-presentation2.0e1c2352.webp";